import './style.scss'
import {Sidebar} from '@components';
import {useGlobalUser} from "@hooks";
import {Typography} from "antd";

const {Text} = Typography;

interface DiferpanHeaderProps {
    title: string;
}

export function DiferpanHeader({title}: DiferpanHeaderProps) {
    const [user] = useGlobalUser();

    const nomeUsuario = user.name
    const codeUsuario = "Código: " + user.code

    return (
        <div className='diferpan-header'>
            <Sidebar/>
            <div className='header-title'>{title}</div>

            <div className={'header-info-logo-class'}>
                <div className='header-info-user-class'>
                    <Text className={'header-info-name-user-text-class'}>{nomeUsuario}</Text>
                    <Text strong className={'header-info-code-user-text-class'}>{codeUsuario}</Text>
                </div>
                <img alt='Diferpan' src="https://cdn.diferpan.com.br/arquivos/publico/sgd/logo/D.png?ts=1726679096282.5"
                     className='d-logo-image-class'/>
            </div>
        </div>
    )
}
